"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _dashboard = require("../../../redux/dashboard/dashboard.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

require("./dashboard.scss");

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  inEditMode: false,
  editedParticipant: {},
  selectedKey: 'posts',
  activeForm: ''
};

class DashboardLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;
  }

  async componentDidMount() {
    this.props.loadDashboardData();
  }

  render() {
    const {
      loadDashboardDataStatus,
      dashboardData,
      studyId,
      showForms,
      showIncentives,
      showTestKits
    } = this.props;

    if (loadDashboardDataStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading");
    }

    if (!dashboardData) {
      return /*#__PURE__*/_react.default.createElement("div", null, " LOADING ... ");
    }

    const {
      testkits,
      payments,
      forum,
      inbox,
      forms,
      qnas
    } = dashboardData;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "dashboard"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "site-card-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      gutter: 16,
      className: "row"
    }, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Inbox",
      className: "card",
      bordered: false
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: "Unread threads that are assigned to you"
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/inbox?view=assigned&filterBy=unread`
    }, ' ', inbox.unreadAssignedThreads, ' ', "Unread assigned threads"))), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: "Unread threads that you've participated in"
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/inbox?view=my&filterBy=unread`
    }, ' ', inbox.unreadMyThreads, ' ', "Unread my threads"))), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: "All unread threads that aren't archived"
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/inbox?view=all&filterBy=unread`
    }, ' ', inbox.unreadThreads, ' ', "Unread threads", ' '))))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Forum",
      className: "card",
      bordered: false
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/forums/uncategorized`
    }, ' ', forum.uncategorized, ' ', "posts uncategorized")), /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/forums/flagged`
    }, ' ', forum.flagged, ' ', "posts/comments flagged")))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Ask The Expert",
      className: "card",
      bordered: false
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/qna/`
    }, ' ', qnas.unansweredCount, ' ', "unanswered questions"))))), /*#__PURE__*/_react.default.createElement(_row.default, {
      gutter: 16,
      className: "row"
    }, showIncentives && /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Incentives",
      className: "card",
      bordered: false
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/payments/`
    }, ' ', payments.unpaid, ' ', "pending payment")))), showForms && /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Forms",
      className: "card",
      bordered: false
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/form`
    }, ' ', forms.openFormsCount, ' ', "open forms")))), showTestKits && /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 8
    }, /*#__PURE__*/_react.default.createElement(_card.default, {
      title: "Test Kits",
      bordered: false,
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/testkits/requested`
    }, ' ', testkits.requestedCount, ' ', "requests awaiting shipment")), /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/testkits/needsreview`
    }, ' ', testkits.needsReviewCount, ' ', "OraQuick reports need review with", ' ', testkits.seroconversionCount, ' ', "possible seroconversions")))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  dashboardData: selectors.selectDashboard,
  loadDashboardDataStatus: selectors.loadDashboardStatus,
  showForms: selectors.getFormsFeatureEnabled,
  showIncentives: selectors.getIncentivesFeatureEnabled,
  showTestKits: selectors.getTestKitsFeatureEnabled
});

const mapDispatchToProps = dispatch => {
  return {
    loadDashboardData: () => dispatch(_dashboard.loadDashboardDataAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DashboardLandingPage);

exports.default = _default;